import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=d81d5f90&scoped=true&"
var script = {}
import style0 from "./logo.vue?vue&type=style&index=0&id=d81d5f90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81d5f90",
  null
  
)

export default component.exports